import { defineInvokeEventa, defineOutboundEventa } from "@moeru/eventa";
//#region src/index.ts
const sendMessages = defineInvokeEventa("chat:send-messages");
const pullMessages = defineInvokeEventa("chat:pull-messages");
const pullAllMessages = defineInvokeEventa("chat:pull-all-messages");
const newMessages = defineOutboundEventa("chat:new-messages");
const chatConfig = defineOutboundEventa("chat:config");
//#endregion
export { chatConfig, newMessages, pullAllMessages, pullMessages, sendMessages };

//# sourceMappingURL=index.mjs.map